export interface DeliveryCompany {
	value: string
	displayName: string
}

export const deliveryCompanies: DeliveryCompany[] = [
	// TODO:: temporary disabled, should enable if we are going to provide this service again
	// {
	// 	value: 'tuttopost',
	// 	displayName: 'TuttoPost (само за София)'
	// },
	// {
	// 	value: 'econt',
	// 	displayName: 'Econt'
	// },
	{
		value: 'speedy',
		displayName: 'Speedy'
	},
	{
		value: 'pigeon',
		displayName: 'Pigeon'
	},
]
